if (!customElements.get('store-locator')) {
  class StoreLocator extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeMap();
    }

    initializeMap() {
      this.inputAddress = this.querySelector('.input-address');
      this.mapWrapper   = this.querySelector('#map-canvas');

      this.mapKey  =  this.mapWrapper?.dataset.mapKey;

      this.mapLocations = this.querySelectorAll('.store-locator__map-address');
      this.mapAddressWrapper = this.querySelector('.store-locator__address');
      this.mapAddressesEncoded = [];
      this.mapAddresses = [];
      this.mapId = [];
      this.markers = {};

      this.initialLng = this.mapLocations[0]?.dataset.lng || 0;
      this.initialLat = this.mapLocations[0]?.dataset.lat || 0;
      this.initialMapId = this.mapLocations[0]?.dataset.mapId || '';

      this.mapLocations.forEach(location => {
        const mapAddress = location.dataset.mapAddress;

        if(mapAddress.trim() != ""){
          const mapAddressEncoded = location.dataset.mapAddressEncoded || encodeURIComponent(mapAddress);
          const mapId = location.dataset.mapId;

          this.mapAddresses.push(mapAddress);
          this.mapAddressesEncoded.push(mapAddressEncoded);
          this.mapId.push(mapId);
        }

        location.addEventListener('mouseover', () => {
          const lat = location.dataset.lat;
          const lng = location.dataset.lng;

          this.locationNotFound.setAttribute('aria-hidden', 'true');

          this.getCoordAddressFromLatLng(lng, lat, location.dataset.mapId);
        });

        location.addEventListener("focusin", () => {
          const lat = location.dataset.lat;
          const lng = location.dataset.lng;
          if(lat && lng){
            const target = { lat: parseFloat(lat), lng: parseFloat(lng) };
            this.map.panTo(target);

            this.locationNotFound.setAttribute('aria-hidden', 'true');

            const index = this.mapId.indexOf(location.dataset.mapId);
            if(this.markers[index]){
              const scroll = false; // prevent scrolling when hovering from list
              google.maps.event.trigger(this.markers[index], 'mouseover',  { latLng: this.markers[index].getPosition() }, { scroll });
            }
          }
        });

        location.addEventListener("focusout", () => {
          const index = this.mapId.indexOf(location.dataset.mapId);
          if(this.markers[index]){
            google.maps.event.trigger(this.markers[index], 'mouseout');
          }
        });

        location.addEventListener('mouseout', () => {
          const index = this.mapId.indexOf(location.dataset.mapId);
          if(this.markers[index]){
            google.maps.event.trigger(this.markers[index], 'mouseout');
          }
        });
      });

      if (!this.mapWrapper || !this.mapKey || this.mapAddresses.length === 0) return;

      this.locationNotFound = this.querySelector('.store-locator__not-found');

      this.maxDistanceMeters  = Number(this.mapWrapper?.dataset.maxDistanceMeters || 15000);
      this.hideIfFar          = String(this.mapWrapper?.dataset.hideIfFar).toLowerCase() === 'true';
      this.autocompleteRadius = Number(this.mapWrapper?.dataset.autocompleteRadiusM || 15000);
      this.countryRestriction = this.mapWrapper?.dataset.country || null;

      this.pinColors = { 
        outline: this.dataset.pinOutlineColor, 
        fill: this.dataset.pinFillColor
      };

      const onReady = async () => {
          this.geocoder = new google.maps.Geocoder();

          if (navigator.permissions?.query) {
            try {
              const { state } = await navigator.permissions.query({ name: 'geolocation' });
              if (state === 'granted') {
                if(this.inputAddress){
                  this.getCurrentAddress();
                  this.myLatLng = await this.getMyLatLng();
                }
              }
            } catch {
            }
          }
          
          this.setupAutocomplete(); // set up autocomplete on the input field
          this.mapAddresses.forEach((address, index) => {
            this.codeAddress(address, index);
          });

          const directionsDisplay = new google.maps.DirectionsRenderer({ draggable: false });
          directionsDisplay.setMap(this.map);

          setTimeout(() => {
            if (this.myLatLng && this.map){ 
              this.map.setCenter(this.myLatLng);
              this.map.setZoom(15);
              const hideNotFoundMessageAfterDelay = false;
              this.getNearByLocation(hideNotFoundMessageAfterDelay);
            } else if (this.mapAddresses.length) { 
              const lat = this.mapLocations[0].dataset.lat;
              const lng = this.mapLocations[0].dataset.lng;
              if(lat && lng){
                const target = { lat: parseFloat(lat), lng: parseFloat(lng) };
                this.map.setCenter(target);
                this.map.setZoom(15);

                const index = 0;
                if(this.markers[index]){
                  const scroll = false; 
                  google.maps.event.trigger(this.markers[index], 'mouseover',  { latLng: this.markers[index].getPosition() }, { scroll });
                }
              }
            }

            setTimeout(() => {
              this.mapWrapper.setAttribute('data-loaded', 'true');
            }, 500);
          }, 300);
      };

      if (window.google?.maps?.Geocoder && window.google.maps.places) {
        onReady();
        return;
      }

      // unique callback per instance to avoid collisions
      const cb  = '__storeLocatorInit_' + Math.random().toString(36).slice(2);
      window[cb] = () => { delete window[cb]; onReady(); };

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.mapKey}&libraries=places,geometry&callback=${cb}`;
      script.async = true;
      document.head.appendChild(script);
    }

    async getCurrentAddress(){
      if (!navigator.geolocation) return;

      await navigator.geolocation.getCurrentPosition(async (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        const latlng = new google.maps.LatLng(lat, lng);

        await this.geocoder.geocode({ location: latlng }, (results, status) => {
            if (status === 'OK' && results && results.length) {
              const address = results[0].formatted_address;
              if(this.inputAddress){
                const inputAddressWrapper = this.inputAddress.closest('.custom-input-wrapper');
                if(inputAddressWrapper) inputAddressWrapper.classList.add('active');
                this.inputAddress.value = address;
              }
            }
        });
      }, () => {
        // user denied geolocation
      }, { enableHighAccuracy: true, maximumAge: 60000, timeout: 10000 });
    }

    getCoordAddressFromLatLng(lng, lat, mapId){
      if(lat && lng){
        const target = { lat: parseFloat(lat), lng: parseFloat(lng) };
        this.map.panTo(target);

        const index = this.mapId.indexOf(mapId);
        if(this.markers[index]){
          const scroll = false; // prevent scrolling when hovering from list
          google.maps.event.trigger(this.markers[index], 'mouseover',  { latLng: this.markers[index].getPosition() }, { scroll });
        }
      }
    }

    async setupAutocomplete() {
      const inputEl = this.querySelector('.input-address');
      if (!inputEl) return;

      const { AutocompleteSessionToken, AutocompleteSuggestion } =
        await google.maps.importLibrary('places');

      let list = this.querySelector('.autocomplete-list');
      if (!list) {
        list = document.createElement('ul');
        list.className = 'autocomplete-list';
        inputEl.parentNode.appendChild(list);
      }

      // request geolocation once, directly from a gesture
      const requestGeoOnGesture = async () => {
        if (this._geoRequested) return;
        this._geoRequested = true;
        this.myLatLng = await this.getMyLatLng(); // may be null if blocked/denied
      };
      
      inputEl.addEventListener('pointerdown', requestGeoOnGesture, { once: true });
      inputEl.addEventListener('focus',       requestGeoOnGesture, { once: true });
      inputEl.addEventListener('keydown',     requestGeoOnGesture, { once: true });

      let token = new AutocompleteSessionToken();
      let t; const debounce = (fn, ms=150) => (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); };

      const render = async () => {
        const q = inputEl.value.trim();
        list.innerHTML = '';
        if (!q) return;

        // build a bias without calling geolocation here (avoids violation)
        let locationBias = null;
        if (this.myLatLng) {
          const center = this.myLatLng.toJSON?.() ?? this.myLatLng; // LatLng or {lat,lng}
          locationBias = { center, radius: this.maxDistanceMeters };
        } else if (this.map) {
          locationBias = { center: this.map.getCenter().toJSON(), radius: this.maxDistanceMeters };
        }

        const req = {
          input: q,
          sessionToken: token,
          ...(locationBias ? { locationBias } : {})
          // you can also add includedRegionCodes, includedPrimaryTypes, etc.
        };

        const { suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions(req);
        suggestions.slice(0, 8).forEach((sugg) => {
          const li = document.createElement('li');
          const p = sugg.placePrediction;
          li.textContent = p.text?.text || p.structuredFormat?.mainText?.text || 'Result';
          li.tabIndex = 0;
          li.addEventListener('mousedown', async (e) => {
            e.preventDefault();
            const place = p.toPlace();
            await place.fetchFields({ fields: ['formattedAddress','location'] });

            inputEl.value = place.formattedAddress || li.textContent;

            const loc = place.location;
            if (loc) {
              if (!this.map) {
                this.map = new google.maps.Map(this.mapWrapper, { center: loc, zoom: 15 });
              } else {
                this.map.panTo(loc); 
                this.map.setZoom(15);
              }

              this.myLatLng = loc;
              this.getNearByLocation();
            }
            list.innerHTML = '';
            token = new AutocompleteSessionToken();
          });
          li.addEventListener('keydown', (e) => { 
            if (e.key === 'Enter') {
              e.preventDefault();
              li.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
            } else if (e.key === 'ArrowDown') {
              e.preventDefault();
              if (li.nextSibling) li.nextSibling.focus();
            } else if (e.key === 'ArrowUp') {
              e.preventDefault();
              if (li.previousSibling) li.previousSibling.focus();
              else inputEl.focus();
            } else if (e.key === 'Escape') {
              inputEl.focus();
              list.innerHTML = '';
            } else if (e.key === 'Tab' && li.nextSibling === null) { 
              list.innerHTML = '';
            }
          });
          list.appendChild(li);
        });
      };

      inputEl.addEventListener('input', debounce(render, 160));
      inputEl.addEventListener('keydown', (e) => { 
        if (e.key === 'Escape') list.innerHTML = '';
        else if((e.key === 'ArrowDown' && list.firstChild) || (e.key === 'Tab' && list.firstChild)){
          e.preventDefault();
          list.firstChild.focus();
        }
      });
    }

    getMyLatLng() {
      return new Promise((resolve) => {
        if (!navigator.geolocation) return resolve(null);
        navigator.geolocation.getCurrentPosition(
          p => resolve(new google.maps.LatLng(p.coords.latitude, p.coords.longitude)),
          () => resolve(null),
          { enableHighAccuracy: true, maximumAge: 50000, timeout: 10000 }
        );
      });
    }

    getMyLatLngFromCoords(lat, lng) {
      return Promise.resolve(
        (Number.isFinite(lat) && Number.isFinite(lng))
          ? new google.maps.LatLng(lat, lng)
          : null
      );
    }

    ensureLatLng = (v) => {
        if (!v) return null;
        if (typeof v.lat === 'function') return v;
        if (typeof v.lat === 'number' && typeof v.lng === 'number') {
            return new google.maps.LatLng(v.lat, v.lng);
        }
        throw new Error('Invalid coordinate supplied to ensureLatLng');
    };

    codeAddress(address, index) {
        this.geocoder.geocode({ address }, (results, status) => {
          if(status === 'OK' && results && results.length){
            const destLoc = this.ensureLatLng(results[0].geometry.location);

            if(!this.map){
              this.map = new google.maps.Map(this.mapWrapper, {
                center: destLoc,
                zoom: 13,
                maxZoom: 16,
                mapTypeControl: false,
                scrollwheel: false,
                fullscreenControl: false,
                streetViewControl: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                zoomControlOptions: { position: google.maps.ControlPosition.TOP_RIGHT }
              });
            }

            // add lat and lng to the map
            const mapId = this.mapId[index];
            const mapAddress = this.querySelector(`.store-locator__map-address[data-map-id="${mapId}"]`);
            if(mapAddress){
              mapAddress.setAttribute('data-lat', destLoc.lat());
              mapAddress.setAttribute('data-lng', destLoc.lng());
            }
            this.addMarker(destLoc, index);
          }else{
            console.error(status === 'OK' ? 'geocoder returned OK but results were empty.' : 'Geocode failed: ' + status);
          }
      });
    }

    displayNotFoundLocation(hideAfterDelay = true) {
      this.locationNotFound.setAttribute('aria-hidden', 'false');

      if(!hideAfterDelay) return;
      setTimeout(() => {
        this.locationNotFound.setAttribute('aria-hidden', 'true');
      }, 5000);
    }

    geocodeAsync(geocoder, address) {
      return new Promise((resolve) => {
        geocoder.geocode({ address }, (results, status) => {
          if (status === 'OK' && results && results.length) {
            resolve(results[0]); // return the first result
          } else {
            resolve(null); // treat non-OK/zero results as null; no throw
          }
        });
      });
    }

    async getNearByLocation(hideNotFoundMessageAfterDelay = true) {
      let nearByLocationNotFound = true;

      if (!this.geocoder || !this.mapAddresses || !this.mapAddresses.length) {
        this.displayNotFoundLocation?.(hideNotFoundMessageAfterDelay);
        return;
      }

      for (const [index, address] of this.mapAddresses.entries()) {
        const result = await this.geocodeAsync(this.geocoder, address);
        if (!result) continue;

        const destLoc = this.ensureLatLng(result.geometry.location);

        if (this.myLatLng) {
          const from = this.ensureLatLng(this.myLatLng);
          const to   = this.ensureLatLng(destLoc);

          const d = google.maps.geometry.spherical.computeDistanceBetween(from, to);

          const isTooFarAndHidden = d > this.maxDistanceMeters && this.hideIfFar;

          if (!isTooFarAndHidden) {
            nearByLocationNotFound = false;
          }
        }
      }

      if (nearByLocationNotFound) {
        this.displayNotFoundLocation?.(hideNotFoundMessageAfterDelay);
      }
    }

    addMarker(location, index){
      const svg = [
        '<?xml version="1.0" encoding="UTF-8"?>',
        '<svg width="32" height="45" viewBox="0 0 32 45" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="map pin">',
        `<path d="M16 45C16 45 0 27 0 16C0 7.163 7.163 0 16 0C24.837 0 32 7.163 32 16C32 27 16 45 16 45Z" fill="${this.pinColors.fill}"/>`,
        `<circle cx="16" cy="16" r="6" fill="${this.pinColors.outline}"/>`,
        '</svg>'
      ].join('\n');

      const marker = new google.maps.Marker({ 
        map: this.map, 
        position: location, 
        icon: { url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg), scaledSize: new google.maps.Size(40, 40) } 
      });

      const mapId = this.mapId[index];
      const mapAddress = this.querySelector(`.store-locator__map-address[data-map-id="${mapId}"]`);
      const mapAddressWrapper = this.mapAddressWrapper;
      google.maps.event.addListener(marker, 'mouseover', function(e, param = {}) { 
        this.setIcon({ url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg), 
          scaledSize: new google.maps.Size(50, 50) 
        });

        if(mapAddress){
          mapAddress.classList.add('hover');
          const scroll = param.scroll !== undefined ? param.scroll : true;
          if(scroll !== false){
            mapAddressWrapper.scrollTop = mapAddress.offsetTop;
          }
        }
      }); 
      google.maps.event.addListener(marker, 'mouseout', function() { 
        this.setIcon({ url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg), 
          scaledSize: new google.maps.Size(40, 40) 
        }); 

        if(mapAddress){
          mapAddress.classList.remove('hover');
        }
      });
      google.maps.event.addListener(marker, 'click', () => {
        window.open(`//maps.google.com/maps?saddr=My+Location&daddr=${this.mapAddressesEncoded[index]}`, '_blank');
      });

      this.markers[index] = marker;
    }
  }

  customElements.define('store-locator', StoreLocator);
}